import { InventoryItemReservationStatus } from "gen/ApiClient";

export const InventoryItemReservationStatusRecord: Record<InventoryItemReservationStatus, string> = {
    PreparedForRental: 'Klaar voor verhuur',
    Present: 'Aanwezig',
    Rented: 'Verhuurd',
}